import React, { useEffect, useState } from 'react'
import './home.css'

const Home = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100)
    return () => clearTimeout(timer)
  }, [])

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className='home' id='home'>
      {/* SWAP_IMAGE — replace background-image URL in home.css with a real hero photo */}
      <div className="home__overlay"></div>
      <div className={`hero-content ${visible ? 'visible' : ''}`}>
        <p className="hero-overline">ONE ROOM · COMPLETE INDULGENCE</p>
        <h1 className="hero-headline">Where Fantasy Becomes Reality</h1>
        <p className="hero-subtext">
          A private escape crafted for every desire.
          Fully equipped. Completely discreet.
        </p>
        <div className="hero-buttons">
          <a href="https://t.me/BookHookupRoom" className="hero-btn hero-btn--primary">
            Book Now on Telegram
          </a>
          <button onClick={scrollToServices} className="hero-btn hero-btn--secondary">
            Our Services
          </button>
        </div>
      </div>

      <div className="hero-marquee-container">
        <div className="hero-marquee">
          <div className="marquee-group">
            <span>Booking.com</span>
            <span>Expedia</span>
            <span>Hotels.com</span>
            <span>Agoda</span>
            <span>Airbnb</span>
          </div>
          <div className="marquee-group">
            <span>Booking.com</span>
            <span>Expedia</span>
            <span>Hotels.com</span>
            <span>Agoda</span>
            <span>Airbnb</span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Home